import comp from "./PersistentNotification";
export default comp;
